import { TRANSFERS_TEXT, TransferTableType } from './Transfers.meta';
import { toast } from '../../../../../../../../../CommonComponents/OPL/Toast/Toast';
import { useCancelTransferMutation } from '../../../../../../../../api/useCancelTransferMutation';
import { useCancelScheduledTransferMutation } from '../../../../../../../../api/useCancelScheduledTransferMutation';
import { useDeleteACATSTransferMutation } from '../../../../../../../../api/useDeleteACATSTransferMutation';
import { useDeleteACHTransferMutation } from '../../../../../../../../api/useDeleteACHTransferMutation';
import { TransferType } from '../../../../../../../../api/useTransfersQuery';

interface UseTransfers {
  managedAccountId: string;
  transferTableType: TransferTableType;
}

export const useTransfers = ({ managedAccountId, transferTableType }: UseTransfers) => {
  const { mutateAsync: cancelTransfer, isLoading: isCancelingTransfer } = useCancelTransferMutation(
    managedAccountId,
  );

  const {
    mutateAsync: cancelScheduledTransfer,
    isLoading: isCancelingScheduledTransfer,
  } = useCancelScheduledTransferMutation(managedAccountId);

  const {
    mutateAsync: deleteACATSTransfer,
    isLoading: isDeletingACATSTransfer,
  } = useDeleteACATSTransferMutation(managedAccountId);

  const {
    mutateAsync: deleteACHTransfer,
    isLoading: isDeletingACHTransfer,
  } = useDeleteACHTransferMutation(managedAccountId);

  const onSubmit = async selectedTransfer => {
    try {
      if (transferTableType === TransferTableType.Pending) {
        await cancelTransfer({
          transferId: selectedTransfer.transferId,
          transferDirection: selectedTransfer.transferDirection,
        });
      } else if (transferTableType === TransferTableType.Scheduled) {
        await cancelScheduledTransfer({
          scheduledTransferId: selectedTransfer.scheduledTransferId,
        });
      } else if (selectedTransfer?.transferType === TransferType.ACATS) {
        await deleteACATSTransfer({
          transferId: selectedTransfer.transferId,
        });
      } else if (selectedTransfer?.transferType === TransferType.ACH) {
        await deleteACHTransfer({
          transferId: selectedTransfer.transferId,
        });
      }

      toast.success(TRANSFERS_TEXT[transferTableType].toastSuccess);
    } catch (err) {
      toast.error(TRANSFERS_TEXT[transferTableType].toastError);
    }
  };

  return {
    data: {
      isLoading:
        isCancelingTransfer ||
        isCancelingScheduledTransfer ||
        isDeletingACATSTransfer ||
        isDeletingACHTransfer,
    },
    actions: {
      onSubmit,
    },
  };
};
